import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import React, { useEffect } from 'react';

import Contact from './contact/Contact';
import Newsletter from './newsletter/Newsletter';
import Producers from './producers/Producers';
import Recommended from './recommended/Recommended';
import Categories from './categories/Categories';
import About from './about/About';
import Banner from './banner/Banner';
import { useConfig } from '../../utils/useConfig';

function Home() {
  const config = useConfig();

  useEffect(() => {
    document.title = `${config.company.name} - Strona Główna`;
  }, [config.company.name]);

  return (
    <div className="flex flex-col justify-start">
      <Banner />
      <div id="categories-section">
        <Categories />
      </div>
      <Recommended />
      <About />
      {/* {config.ui.home.showNewsletterForm && <Newsletter />} */}
      <Contact />
      <Producers />
    </div>
  );
}

export default Home;
